import { Variant } from "@/types/types";

export const getBundleServices = (variant: Variant): any => {
  const bundleVariant = variant?.components?.[0]?.variant;
  return bundleVariant &&
    "services" in bundleVariant &&
    bundleVariant?.services?.length
    ? bundleVariant.services
    : [];
};
